/** Read vs unread — background only; same for every inbox row type. */
export const INBOX_READ_ROW =
  'border border-surface-200/90 bg-white/95 dark:border-surface-700/80 dark:bg-surface-900/85';

export const INBOX_UNREAD_ROW =
  'border border-sky-200/85 bg-[rgb(204_229_255_/_95%)] dark:border-[rgb(125_211_252_/_0.38)] dark:bg-[rgb(22_46_74_/_0.94)]';

export const INBOX_ROW_FRAME =
  'flex w-full items-start gap-3 rounded-[18px] px-4 py-3.5 text-left shadow-sm transition-all duration-200 hover:-translate-y-0.5 dark:shadow-none';
